<div class="container mt-5">
  <h2 class="mb-4">Create a Bill for Your Client</h2>
  <form [formGroup]="billingForm" (ngSubmit)="onSubmit()">
    <!-- Client Information Section -->
    <div class="card mb-4">
      <div class="card-header bg-primary text-white">Client Information</div>
      <div class="card-body">
        <div class="mb-3">
          <label for="clientName" class="form-label">Client Name</label>
          <input type="text" id="clientName" class="form-control" formControlName="clientName" placeholder="Enter client's full name">
          <div *ngIf="billingForm.get('clientName')?.invalid && billingForm.get('clientName')?.touched" class="text-danger">
            Client name is required.
          </div>
        </div>
        <div class="mb-3">
          <label for="clientEmail" class="form-label">Client Email</label>
          <input type="email" id="clientEmail" class="form-control" formControlName="clientEmail" placeholder="Enter client's email">
          <div *ngIf="billingForm.get('clientEmail')?.invalid && billingForm.get('clientEmail')?.touched" class="text-danger">
            Valid email is required.
          </div>
        </div>
        <div class="mb-3">
          <label for="clientAddress" class="form-label">Client Address</label>
          <textarea id="clientAddress" class="form-control" formControlName="clientAddress" rows="3" placeholder="Enter client's address"></textarea>
          <div *ngIf="billingForm.get('clientAddress')?.invalid && billingForm.get('clientAddress')?.touched" class="text-danger">
            Client address is required.
          </div>
        </div>
      </div>
    </div>

    <!-- Web Creation Services Section -->
    <div class="card mb-4">
      <div class="card-header bg-secondary text-white">Web Creation Services</div>
      <div class="card-body">
        <div class="mb-3">
          <label for="webCreationType" class="form-label">Select Web Creation Service</label>
          <select id="webCreationType" class="form-select" formControlName="webCreationType">
            <option value="">Select a service</option>
            <option *ngFor="let service of pricingData?.webCreation" [value]="service.type">{{ service.type }}&nbsp;<i>({{service.basePrice}})</i></option>
          </select>
          <div *ngIf="billingForm.get('webCreationType')?.invalid && billingForm.get('webCreationType')?.touched" class="text-danger">
            Please select a web creation service.
          </div>
        </div>
        <div *ngIf="selectedWebCreation">
          <div class="mb-3">
            <label for="numberOfPages" class="form-label">Number of Pages</label>
            <input type="number" id="numberOfPages" class="form-control" formControlName="numberOfPages" min="1" placeholder="Enter number of pages">
            <div *ngIf="billingForm.get('numberOfPages')?.invalid && billingForm.get('numberOfPages')?.touched" class="text-danger">
              Please enter a valid number of pages.
            </div>
          </div>
          <div class="mb-3" formArrayName="selectedOptions">
            <label class="form-label">
              Additional Options
              <div *ngFor="let option of selectedWebCreation.options; let i = index" class="form-check">
                <input class="form-check-input" type="checkbox" [id]="'option' + i" [formControlName]="i">
                <label class="form-check-label" [for]="'option' + i">
                  {{ option.name }} - {{ option.price }}
                </label>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Maintenance Plans Section -->
    <div class="card mb-4">
      <div class="card-header bg-success text-white">Maintenance Plans</div>
      <div class="card-body">
        <div class="mb-3">
          <label for="maintenancePlan" class="form-label">Select Maintenance Plan</label>
          <select id="maintenancePlan" class="form-select" formControlName="maintenancePlan">
            <option value="">Select a plan (optional)</option>
            <option *ngFor="let plan of pricingData?.maintenance" [value]="plan.name">{{ plan.name }} - {{ plan.price }}</option>
          </select>
        </div>
        <div *ngIf="selectedMaintenancePlan">
          <h5>Features:</h5>
          <ul>
            <li *ngFor="let feature of selectedMaintenancePlan.features">{{ feature }}</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Summary Section -->
    <div class="card mb-4">
      <div class="card-header bg-info text-white">Summary</div>
      <div class="card-body">
        <p><strong>Client Name:</strong> {{ billingForm.value.clientName }}</p>
        <p><strong>Client Email:</strong> {{ billingForm.value.clientEmail }}</p>
        <p><strong>Web Creation Service:</strong> {{ billingForm.value.webCreationType }}</p>
        <p><strong>Number of Pages:</strong> {{ billingForm.value.numberOfPages }}</p>
        <p><strong>Selected Options:</strong> {{ get_number_of_true(billingForm.value.selectedOptions) }}</p>
        <p><strong>Maintenance Plan:</strong> {{ billingForm.value.maintenancePlan }}</p>
        <h4><strong>Total Price:</strong> {{ totalPrice | currency:'EUR' }}</h4>
        <h6 *ngIf="monthlyPayment"><strong>Additional fees: </strong>{{ monthlyPayment | currency:'EUR'}} / month</h6>
      </div>
    </div>

    <!-- Submit Button -->
    <button type="submit" class="btn btn-primary" [disabled]="billingForm.invalid">Generate Bill</button>
  </form>
</div>
